import React from 'react';
import { isNil } from 'lodash';
import Anchor from '../../../../components/link/Anchor';
import InfoTable from '../../../../components/table/InfoTable';
import { asyncSimpleModal, setDash, setNumberWithComma } from '../../../../lib/common';
import { setDateFormat } from '../../../../lib/moment';
import {
  DEPOSIT_TIME_EXCEEDED_TEXT,
  ORDER_ACCEPT_MANAGER_TEXT,
  ORDER_CANCEL_STATUS,
  ORDER_CANCEL_STATUS_TEXT,
  ORDER_CANCEL_TYPE_TEXT,
  ORDER_PROCESS_MANAGER_TEXT,
} from '../../../../constants/service/app/orderConstants';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';

const OrderCancelHistory = (props) => {
  const { cancelHistory } = props;

  if (!cancelHistory.length) return null;
  return (
    <div className="order-detail-content">
      {/* 취소 처리 이력 */}
      <div className="order-detail-section">
        <div className="title">취소 처리 이력</div>
        {cancelHistory.map((item, index) => (
          <div key={index} className="order-cancel-history-table">
            {index + 1}.
            <InfoTable className="order-cancel-history">
              <tbody>
                <tr>
                  <td className="label tc" colSpan={2}>
                    취소 처리 상태
                  </td>
                  <td className="tc" colSpan={2}>
                    {
                      /**
                       *  입금 기한 초과시 스케줄러에서 상품 주문서의 상태를 취소로 만들어주고 OrderCancel 을
                       *  만들어주지 않기 때문에
                       *  OrderCancel 가 없는 row 은 "입금 기한 초과" 텍스트를 보여준다.
                       */
                      isNil(item.orderCancelStatus)
                        ? DEPOSIT_TIME_EXCEEDED_TEXT
                        : ORDER_CANCEL_STATUS_TEXT[item.orderCancelStatus]
                    }
                  </td>
                </tr>
                <tr>
                  <td className="label tc">실제 고객 결제금액</td>
                  <td className="tc">{setDash(setNumberWithComma(item.totalPrice, '원'))}</td>
                  <td className="label tc">실제 고객 환불금액</td>
                  <td className="tc">{setDash(setNumberWithComma(item.refundActualAmount, '원'))}</td>
                </tr>
                <tr>
                  <td className="label tc">취소 사유</td>
                  <td className="tc">
                    {!isNil(item.cancelType) ? (
                      <Anchor
                        color="primary"
                        isUnderLine
                        onClick={async () =>
                          await asyncSimpleModal({
                            title: '취소 사유',
                            message: item.cancelReason,
                          })
                        }
                        text={ORDER_CANCEL_TYPE_TEXT[item.cancelType]}
                      />
                    ) : (
                      '-'
                    )}
                  </td>
                  <td className="label tc">취소 거부 사유</td>
                  <td className="tc">
                    {!isNil(item.rejectReason) ? (
                      <Anchor
                        color="primary"
                        isUnderLine
                        onClick={async () =>
                          await asyncSimpleModal({
                            title: '취소 거부 사유',
                            message: item.rejectReason,
                          })
                        }
                        text="내용 보기"
                      />
                    ) : (
                      '-'
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="label tc">접수자</td>
                  <td className="tc">{setDash(ORDER_ACCEPT_MANAGER_TEXT[item.acceptManager])}</td>
                  <td className="label tc">취소처리자</td>
                  <td className="tc">{setDash(ORDER_PROCESS_MANAGER_TEXT[item.cancelManager])}</td>
                </tr>
                <tr>
                  <td className="label tc" colSpan={2}>
                    취소 요청 일시
                  </td>
                  <td className="tc" colSpan={2}>
                    {setDash(setDateFormat(item.canceledDate, DATE_FORMAT.FULL_DASH_FORMAT))}
                  </td>
                </tr>
                <tr>
                  <td className="label tc" colSpan={2}>
                    취소 철회 일시
                  </td>
                  <td className="tc" colSpan={2}>
                    {setDash(setDateFormat(item.cancelWithDrawDate, DATE_FORMAT.FULL_DASH_FORMAT))}
                  </td>
                </tr>
                <tr>
                  <td className="label tc" colSpan={2}>
                    취소 거부 일시
                  </td>
                  <td className="tc" colSpan={2}>
                    {setDash(setDateFormat(item.rejectDate, DATE_FORMAT.FULL_DASH_FORMAT))}
                  </td>
                </tr>
                <tr>
                  <td className="label tc" colSpan={2}>
                    취소 완료 일시
                  </td>
                  <td className="tc" colSpan={2}>
                    {/*취소 상태가 취소 완료일때는 입금 대기에서 구매 취소를 했을 경우이다.*/}
                    {item.orderCancelStatus === ORDER_CANCEL_STATUS.CANCEL_COMPLETE
                      ? setDash(setDateFormat(item.cancelCompleteDate, DATE_FORMAT.FULL_DASH_FORMAT))
                      : '-'}
                  </td>
                </tr>
                <tr>
                  <td className="label tc" colSpan={2}>
                    환불 완료 일시
                  </td>
                  <td className="tc" colSpan={2}>
                    {/*입금 대기에서 구매 취소를 한게 아닌 경우(실제 돈이 오간 경우)*/}
                    {item.orderCancelStatus !== ORDER_CANCEL_STATUS.CANCEL_COMPLETE
                      ? setDash(setDateFormat(item.cancelCompleteDate, DATE_FORMAT.FULL_DASH_FORMAT))
                      : '-'}
                  </td>
                </tr>
              </tbody>
            </InfoTable>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderCancelHistory;
